import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { unitByIdQueryOptions } from '@/service/vpc/queryOptions';

export const loaderUnitSettingsPage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // First fetch the unit data to get serial numbers and chassis IDs
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));
  return { unitData, endCustomerUnitId };
};
